import { gql, useQuery } from '@apollo/client';
import {
  DayAvailability,
  QueryListEntranceAvailabilityArgs,
} from 'apollo/generated/types';

const LIST_ENTRANCE_AVAILABILITY = gql`
  query listEntranceAvailability($id: ID!, $startDate: String!, $endDate: String!) {
    listEntranceAvailability(id: $id, startDate: $startDate, endDate: $endDate) {
      day
      remaining
      aggregateRemaining
    }
  }
`;

const useListEntranceAvailabilityQuery = (
  id: string,
  startDate: string,
  endDate: string,
  skip?: boolean
) => {
  const query = useQuery<
    { listEntranceAvailability: DayAvailability[] },
    QueryListEntranceAvailabilityArgs
  >(LIST_ENTRANCE_AVAILABILITY, {
    variables: { id, startDate, endDate },
    skip,
  });
  return query.data?.listEntranceAvailability;
};

export default useListEntranceAvailabilityQuery;
